module.exports = __webpack_public_path__ + "img/bottom.6ac574b6.png";